import { Uploader } from './uploader'

interface Info {
  fileType: string
  fileSize: number
  startTime: number
  tokenEndTime?: number
}

export class Response<T = Record<string, any>> {
  success: boolean

  code: number

  msg?: string

  data?: T

  info: Info

  static getLogger(): any {
    // @ts-ignore
    return (window.eaglet.sendApm && window.eaglet) || global.eaglet
  }

  constructor(
    {
      success = true,
      code = 0,
      info,
    }: {
      success?: boolean
      code?: number
      info: Info
    },
  ) {
    this.success = success
    this.code = code
    this.info = info
  }

  setCode(code: number): Response<T> {
    this.code = code

    return this
  }

  setMsg(msg?: string): Response<T> {
    this.msg = msg

    return this
  }

  setData(data?: T): Response<T> {
    this.data = data

    return this
  }

  setInfo(info: Info): Response<T> {
    this.info = info
    return this
  }

  fail(): Response<T> {
    this.success = false
    this.code = -1

    return this
  }

  // eslint-disable-next-line
  log(uploader: Uploader, metrics?: any): Response<T> {

    try {
      const payload = {
        // 业务名称
        bizName: uploader.bizName,
        // 业务线
        scene: uploader.scene,
        customerHost: window.location.host,
        routePath: window.location.pathname,
        uploadSuccess: this.success,
        // 状态码
        code: this.code,
        // error信息
        errorMsg: this.msg,
        // uploader 传给业务方的 data
        successData: JSON.stringify(this.data),
        fileType: this.info.fileType,
        fileSize: this.info.fileSize,
        startTime: Response.formatDate(this.info.startTime),
        endTime: Response.formatDate(Date.now()),
        tokenStartTime: Response.formatDate(this.info.startTime),
        tokenEndTime: Response.formatDate(this.info.tokenEndTime || Date.now()),
        tokenTimestamp: (this.info.tokenEndTime || Date.now()) - this.info.startTime,
        uploadTimestamp: Date.now() - this.info.startTime,
        ...metrics,
      }

      if (payload.uploadSuccess && payload.uploadTimestamp !== 0) {
        payload.uploadSpeed = payload.fileSize / payload.uploadTimestamp
      }

      const logger = Response.getLogger()

      if (logger) {
        logger
          .push(
            {
              type: 'InfraUploader',
              value: payload,
            },
            'ApmJSONTracker',
          )
      } else {
        const noConsole = console.warn.bind(console)
        noConsole('[APM Warning]: eaglet is undefined, web app please install @xhs/launcher-plugin-eaglet, react-native app use eaglet plugin from asgard!')
      }

      const reportToXray = (window as any)?.insight?.sendCustomPoint.bind((window as any)?.insight) || logger?.flushApm

      if (reportToXray) {
        // apm 不支持 bool
        Object.keys(payload).forEach(key => {
          if (typeof payload[key] === 'boolean') payload[key] = Number(payload[key])
        })

        reportToXray({
          measurement_name: 'infraUploader',
          measurement_data: payload,
        }, 'ApmXrayTracker')
      }
    } finally {
      // eslint-disable-next-line no-unsafe-finally
      return this
    }
  }

  static formatDate(timestamp: number): string {
    return new Date(timestamp)
      .toISOString()
      .replace(/T/, ' ')
      .replace(/\..+/, '')
  }
}
// eslint-disable-next-line no-useless-escape
export const toHump = (str: string): string => str.replace(/\-(\w)/g, letter => letter[1].toUpperCase())
